/**
 * Component: Site selector
 */


var ed = ed || {};

ed.siteSelector = new function(){
    var siteSelector = $('#js-site-selector'),
        siteSelectorButton = $('#js-site-selector__button'),
        siteSelectorList = $('#js-site-selector-list');

    /**
     * Init function
     */
    this.init = function() {
        siteSelectorList.hide();
        siteSelectorButton.on('click', function(){
            siteSelectorList.slideToggle(300);
            $(this).toggleClass('site-selector__button--active');
        });
    };

    /**
     * Place site selector
     * Because of the layout of the site selector, there's no room for it, in the mobile header.
     * Therefore, we move the site selector into the site navigation on smaller screens, and back again, on larger
     */
    this.place = function() {
        var siteNavigationHeader = $('#site-navigation .site-navigation-header'),
            siteSearch = $('#site-search');

        if (window.innerWidth < 1025) {
            // mobile view
            siteSelector.insertAfter(siteNavigationHeader);
        }
        else {
            // desktop view
            siteSelector.insertAfter(siteSearch);
        }
    };
};
